export default __webpack_public_path__ + "static/media/IUSD+_old.828243c7.png";